import { Component, OnInit, Input, EventEmitter, Output, OnDestroy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-new-guest-modal",
  templateUrl: "./new-guest-modal.component.html",
  styleUrls: ["./new-guest-modal.component.scss"]
})
export class NewGuestModalComponent implements OnInit, OnDestroy {
  record: any = {};
  isEditMode: boolean = false;
  allPlatformsPattern: string = "^(?:https?:\\/\\/)?(?:www\\.)?(?:(?:facebook\\.com\\/(?:(?:\\w)*#!\\/)?(?:pages\\/)?(?:[?\\w\\-]*\\/)?(?:profile\\.php\\?id=)?|m\\.facebook\\.com\\/(?:(?:\\w)*#!\\/)?(?:profile\\.php\\?id=))([^\\s&]+))(?:&.*)?$|(?:instagram\\.com\\/([^\\s\\/&]+))|(?:https?:\\/\\/x\\.com\\/([^\\s\\/&]+))(?:\\?.*)?$";
  instagramOnlyPattern: string = "^(?:https?:\\/\\/)?(?:www\\.)?instagram\\.com\\/([^\\s\\/&]+)$";
  @Input() SocialMediaLinkCustomLabel!: string;
  @Input() acceptInstagramOnly!: boolean;
  @Input() isTicketType;
  @Input() ticketPrices;
  @Input() resTypeId;
  @Input() fbGuestMandatory: boolean;
  @Input() emailGuestMandatory: boolean;
  @Input() mobileNumberAtGlMandatory: boolean;
  @Input() acceptInternationalNumbers: boolean;
  @Output() save = new EventEmitter<any>();
mobileNoIsReadOnly = false;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.record.contactmethod = "1";
    if (this.record.gender != "m" && this.record.gender != "f") {
      this.record.gender = "m";
    }

   // console.log(this.SocialMediaLinkCustomLabel, this.acceptInstagramOnly);
  }

  ngOnDestroy() {
    this.save.unsubscribe();
    this.save = null;
  }

  prepareForEdit(record) {
    this.record = { ...record };
    this.isEditMode = true;
  }

  onSubmit() {
    if (this.isFormValid()) {
      this.record._dirty = true;
      this.save.emit(this.record);
      this.activeModal.close();
    } else {
      return false;
    }
  }

  isFormValid() {
    return this.record.fname && this.record.lname &&
      (!this.mobileNumberAtGlMandatory || this.record.mobileno) &&
      (!this.isTicketType || this.record.ticketcat_id) &&
      (!this.emailGuestMandatory || this.record.email) &&
      (!this.fbGuestMandatory || this.record.fblink); 
      
  }

  onKeyPress(event: KeyboardEvent) {
    const char = String.fromCharCode(event.charCode);
    if (!/^\d+$/.test(char)) { // Regular expression to allow only digits
      event.preventDefault();
    }
  }
}
